export function isTestEnv() {
  return process.env.NODE_ENV === 'test';
}

export function isNotTestEnv() {
  return process.env.NODE_ENV !== 'test';
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/test_env_helper.ts